/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addCommentaryTicket } from '../fn/manage-ticket-api/add-commentary-ticket';
import { AddCommentaryTicket$Params } from '../fn/manage-ticket-api/add-commentary-ticket';
import { ApiResponseConversation } from '../models/api-response-conversation';
import { ApiResponseListString } from '../models/api-response-list-string';
import { ApiResponseListTicketCategory } from '../models/api-response-list-ticket-category';
import { ApiResponseListTicketDistributionDto } from '../models/api-response-list-ticket-distribution-dto';
import { ApiResponseListTicketStatus } from '../models/api-response-list-ticket-status';
import { ApiResponseManageTicket } from '../models/api-response-manage-ticket';
import { ApiResponsePageManageTicket } from '../models/api-response-page-manage-ticket';
import { createManageTicket } from '../fn/manage-ticket-api/create-manage-ticket';
import { CreateManageTicket$Params } from '../fn/manage-ticket-api/create-manage-ticket';
import { getAll } from '../fn/manage-ticket-api/get-all';
import { GetAll$Params } from '../fn/manage-ticket-api/get-all';
import { getAllStatus } from '../fn/manage-ticket-api/get-all-status';
import { GetAllStatus$Params } from '../fn/manage-ticket-api/get-all-status';
import { getConversationOfTicket } from '../fn/manage-ticket-api/get-conversation-of-ticket';
import { GetConversationOfTicket$Params } from '../fn/manage-ticket-api/get-conversation-of-ticket';
import { getConversationUnreadTicketCount } from '../fn/manage-ticket-api/get-conversation-unread-ticket-count';
import { GetConversationUnreadTicketCount$Params } from '../fn/manage-ticket-api/get-conversation-unread-ticket-count';
import { getManageTicket } from '../fn/manage-ticket-api/get-manage-ticket';
import { GetManageTicket$Params } from '../fn/manage-ticket-api/get-manage-ticket';
import { getTicketDistribution } from '../fn/manage-ticket-api/get-ticket-distribution';
import { GetTicketDistribution$Params } from '../fn/manage-ticket-api/get-ticket-distribution';
import { getUsersForTicket } from '../fn/manage-ticket-api/get-users-for-ticket';
import { GetUsersForTicket$Params } from '../fn/manage-ticket-api/get-users-for-ticket';
import { markTicketSeen } from '../fn/manage-ticket-api/mark-ticket-seen';
import { MarkTicketSeen$Params } from '../fn/manage-ticket-api/mark-ticket-seen';
import { searchManageTicket } from '../fn/manage-ticket-api/search-manage-ticket';
import { SearchManageTicket$Params } from '../fn/manage-ticket-api/search-manage-ticket';
import { TicketUnreadCount } from '../models/ticket-unread-count';
import { updateManageTicket } from '../fn/manage-ticket-api/update-manage-ticket';
import { UpdateManageTicket$Params } from '../fn/manage-ticket-api/update-manage-ticket';

@Injectable({ providedIn: 'root' })
export class ManageTicketApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateManageTicket()` */
  static readonly UpdateManageTicketPath = '/v1/api/ui/manage-ticket/update/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateManageTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateManageTicket$Response(params: UpdateManageTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicket>> {
    return updateManageTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateManageTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateManageTicket(params: UpdateManageTicket$Params, context?: HttpContext): Observable<ApiResponseManageTicket> {
    return this.updateManageTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseManageTicket>): ApiResponseManageTicket => r.body)
    );
  }

  /** Path part for operation `addCommentaryTicket()` */
  static readonly AddCommentaryTicketPath = '/v1/api/ui/manage-ticket/commentary/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCommentaryTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCommentaryTicket$Response(params: AddCommentaryTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicket>> {
    return addCommentaryTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addCommentaryTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCommentaryTicket(params: AddCommentaryTicket$Params, context?: HttpContext): Observable<ApiResponseManageTicket> {
    return this.addCommentaryTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseManageTicket>): ApiResponseManageTicket => r.body)
    );
  }

  /** Path part for operation `searchManageTicket()` */
  static readonly SearchManageTicketPath = '/v1/api/ui/manage-ticket/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchManageTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchManageTicket$Response(params: SearchManageTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePageManageTicket>> {
    return searchManageTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchManageTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchManageTicket(params: SearchManageTicket$Params, context?: HttpContext): Observable<ApiResponsePageManageTicket> {
    return this.searchManageTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePageManageTicket>): ApiResponsePageManageTicket => r.body)
    );
  }

  /** Path part for operation `getTicketDistribution()` */
  static readonly GetTicketDistributionPath = '/v1/api/ui/manage-ticket/distribution-of-tickets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTicketDistribution()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTicketDistribution$Response(params: GetTicketDistribution$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTicketDistributionDto>> {
    return getTicketDistribution(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTicketDistribution$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTicketDistribution(params: GetTicketDistribution$Params, context?: HttpContext): Observable<ApiResponseListTicketDistributionDto> {
    return this.getTicketDistribution$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListTicketDistributionDto>): ApiResponseListTicketDistributionDto => r.body)
    );
  }

  /** Path part for operation `createManageTicket()` */
  static readonly CreateManageTicketPath = '/v1/api/ui/manage-ticket/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createManageTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createManageTicket$Response(params: CreateManageTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicket>> {
    return createManageTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createManageTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createManageTicket(params: CreateManageTicket$Params, context?: HttpContext): Observable<ApiResponseManageTicket> {
    return this.createManageTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseManageTicket>): ApiResponseManageTicket => r.body)
    );
  }

  /** Path part for operation `getConversationOfTicket()` */
  static readonly GetConversationOfTicketPath = '/v1/api/ui/manage-ticket/conversation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConversationOfTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getConversationOfTicket$Response(params: GetConversationOfTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversation>> {
    return getConversationOfTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConversationOfTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getConversationOfTicket(params: GetConversationOfTicket$Params, context?: HttpContext): Observable<ApiResponseConversation> {
    return this.getConversationOfTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseConversation>): ApiResponseConversation => r.body)
    );
  }

  /** Path part for operation `getAllStatus()` */
  static readonly GetAllStatusPath = '/v1/api/ui/manage-ticket/status/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStatus$Response(params?: GetAllStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTicketStatus>> {
    return getAllStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStatus(params?: GetAllStatus$Params, context?: HttpContext): Observable<ApiResponseListTicketStatus> {
    return this.getAllStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListTicketStatus>): ApiResponseListTicketStatus => r.body)
    );
  }

  /** Path part for operation `getConversationUnreadTicketCount()` */
  static readonly GetConversationUnreadTicketCountPath = '/v1/api/ui/manage-ticket/unread-count/{conversationReference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConversationUnreadTicketCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConversationUnreadTicketCount$Response(params: GetConversationUnreadTicketCount$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketUnreadCount>> {
    return getConversationUnreadTicketCount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConversationUnreadTicketCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConversationUnreadTicketCount(params: GetConversationUnreadTicketCount$Params, context?: HttpContext): Observable<TicketUnreadCount> {
    return this.getConversationUnreadTicketCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketUnreadCount>): TicketUnreadCount => r.body)
    );
  }

  /** Path part for operation `markTicketSeen()` */
  static readonly MarkTicketSeenPath = '/v1/api/ui/manage-ticket/mark-seen/{ticketReference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markTicketSeen()` instead.
   *
   * This method doesn't expect any request body.
   */
  markTicketSeen$Response(params: MarkTicketSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return markTicketSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markTicketSeen$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markTicketSeen(params: MarkTicketSeen$Params, context?: HttpContext): Observable<void> {
    return this.markTicketSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getUsersForTicket()` */
  static readonly GetUsersForTicketPath = '/v1/api/ui/manage-ticket/getUsersForTicket';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsersForTicket()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersForTicket$Response(params: GetUsersForTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListString>> {
    return getUsersForTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsersForTicket$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsersForTicket(params: GetUsersForTicket$Params, context?: HttpContext): Observable<ApiResponseListString> {
    return this.getUsersForTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListString>): ApiResponseListString => r.body)
    );
  }

  /** Path part for operation `getManageTicket()` */
  static readonly GetManageTicketPath = '/v1/api/ui/manage-ticket/get/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManageTicket()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManageTicket$Response(params: GetManageTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicket>> {
    return getManageTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManageTicket$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManageTicket(params: GetManageTicket$Params, context?: HttpContext): Observable<ApiResponseManageTicket> {
    return this.getManageTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseManageTicket>): ApiResponseManageTicket => r.body)
    );
  }

  /** Path part for operation `getAll()` */
  static readonly GetAllPath = '/v1/api/ui/manage-ticket/category/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAll$Response(params?: GetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTicketCategory>> {
    return getAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAll(params?: GetAll$Params, context?: HttpContext): Observable<ApiResponseListTicketCategory> {
    return this.getAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListTicketCategory>): ApiResponseListTicketCategory => r.body)
    );
  }

}
